var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNativescript = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMinYMin meet",
  viewBox: "0 0 256 256",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3c5afd",
  d: "M237 19q18 18 19 45v128a64 64 0 0 1-64 64H64q-27-1-45-19a64 64 0 0 1-19-45V64q1-27 19-45T64 0h128q27 1 45 19m-17 103q-6-6-7-15V64q0-9-6-15t-15-6h-21v106L85 43H64a21 21 0 0 0-21 21v43q-1 9-7 15t-15 6q9 0 15 6 7 6 7 15v43q0 9 6 15t15 6h21V107l86 106h21a21 21 0 0 0 21-21v-43q1-9 7-15t15-6q-9 0-15-6"
})));
export default SvgNativescript;